import React from 'react';
import { useTranslation } from 'react-i18next';
import { BdsIcon, BdsTooltip, BdsButtonGroup } from '@/core/constants/webComponents';
import {
  type Gender,
  type Sentiment,
  GENDER_OPTIONS,
  SENTIMENT_OPTIONS,
  GENDER_ICONS,
  SENTIMENT_ICONS,
  SENTIMENT_COLORS,
} from '@/core/constants/domainMappings';

interface ClassificationSectionProps {
  gender: Gender | null;
  sentiment: Sentiment | null;
  onGenderChange: (option: Gender) => void;
  onSentimentChange: (option: Sentiment) => void;
  GENDER_LABELS: Record<Gender, string>;
  SENTIMENT_LABELS: Record<Sentiment, string>;
}

export const ClassificationSection: React.FC<ClassificationSectionProps> = ({
  gender,
  sentiment,
  onGenderChange,
  onSentimentChange,
  GENDER_LABELS,
  SENTIMENT_LABELS,
}) => {
  const { t } = useTranslation();

  return (
    <div className="classification-card__classification-section">
      <BdsButtonGroup
        color="content"
        direction="row"
        size="medium"
        class="classification-card__toggle-group"
      >
        {GENDER_OPTIONS.map((option) => (
          <BdsTooltip
            key={option}
            position="top-left"
            tooltipText={gender === option ? t('classificationCard.tooltipUnmarkGender') : t('classificationCard.tooltipMarkGender', {
              gender: GENDER_LABELS[option],
            })}
          >
            <button
              className={`classification-card__toggle-btn ${gender === option ? ' classification-card__toggle-btn--active' : ''} btn-${option}`}
              onClick={() => onGenderChange(option)}
            >
              {GENDER_LABELS[option]}
              <BdsIcon name={GENDER_ICONS[option]} size="medium" />
            </button>
          </BdsTooltip>
        ))}
      </BdsButtonGroup>

      <BdsButtonGroup
        color="content"
        direction="row"
        size="medium"
        class="classification-card__toggle-group"
      >
        {SENTIMENT_OPTIONS.map((option) => {
          const sentimentIconColor = SENTIMENT_COLORS[option];
          return (
          <BdsTooltip
            key={option}
            position="top-left"
            tooltipText={sentiment === option ? t('classificationCard.tooltipUnmarkSentiment') : t('classificationCard.tooltipMarkSentiment', {
            sentiment: SENTIMENT_LABELS[option],
          })}
        >
          <button
            className={`classification-card__toggle-btn ${sentiment === option ? ' classification-card__toggle-btn--active' : ''} btn-${option} `}
            onClick={() => onSentimentChange(option)}
          >
            {SENTIMENT_LABELS[option]}
            <BdsIcon color={sentimentIconColor} name={SENTIMENT_ICONS[option]} size="medium" />
          </button>
        </BdsTooltip>
          );
        })}
      </BdsButtonGroup>
    </div>
  );
};
